import { Society } from "./society.model";

export class Category{
    id: number;
	name: string;
	unit: string;
    observation: string;
    society: Society;

    constructor(){
        this.society = new Society();
    }
}

export class CategoryForm{
    id: number;
	name: string;
	unit: string;
    observation: string;
    society: number;
    
    constructor(){}
}